import { log, errorLog } from '@/utils/logger';
import socketClient from '@/services/SocketClient';
import Push from '@/services/NotificationPush';
import { filterCall, isRecipient } from './utils';
import wait from '@/utils/wait';
import Call from '@/services/Call';
import router from '@/router';

export default {
  init: async ({
    commit,
    dispatch,
    state: { subscriptionId },
    rootGetters,
  }) => {
    try {
      await socketClient.connectPromise();
      if (subscriptionId) await socketClient.unsubscribe(subscriptionId);

      const { professionalToken } = rootGetters['dashboard/currWorkspace'];
      const subscription = socketClient.subscribe(
        `/topic/chamada/${professionalToken}`,
        message => {
          const msg = JSON.parse(message.body);
          dispatch('resolveMessage', msg);
        },
      );
      commit('SET_SUBSCRIPTION_ID', subscription.id);
    } catch (err) {
      errorLog(err);
    }
  },

  notifyRequest: (ctx, call) => {
    const { senderName, callType, photoUrl } = call;

    Push.create(`Nova chamada de ${callType}`, {
      body: `${senderName} está chamando...`,
      icon: photoUrl,
      lang: 'pt-BR',
    });
  },

  resolveMessage: ({ dispatch }, msg) => {
    log('message>', msg);
    const dict = {
      CONTATAR: isRecipient(msg) ? 'recipientRequestCall' : null,
      CANCELAR: isRecipient(msg) ? 'recipientCancelCall' : null,
      ACEITAR: isRecipient(msg) ? 'recipientAcceptCall' : null,
    };

    const currAction = dict[msg.tipo];

    if (!currAction) return;

    dispatch(currAction, msg);
  },

  resetCallAndCloseModal: async ({ commit, dispatch }) => {
    dispatch('dashboard/closeModals', null, {
      root: true,
    });
    await wait(400);
    commit('SET_CURRENT_CALL', null);
  },

  recipientRequestCall: ({ commit, dispatch }, msg) => {
    if (msg.tipoCliente !== 'DESTINATARIO') return;

    const filteredCall = filterCall(msg.chamada);

    commit('SET_CURRENT_CALL', filteredCall);
    dispatch('notifyRequest', filteredCall);
    dispatch('dashboard/toggleModal', 'requestedInterConsultation', {
      root: true,
    });
  },

  recipientCancelCall: async ({ dispatch }, msg) => {
    if (msg.tipoCliente !== 'DESTINATARIO') return;

    await dispatch('resetCallAndCloseModal');
  },

  refuseCall: async ({ commit, dispatch }, callId) => {
    commit('SET_LOADING', { refusing: true });

    try {
      await Call.refuse(callId);
      await dispatch('resetCallAndCloseModal');
    } catch (err) {
      errorLog(err);
      alert('Houve um erro ao recusar a chamada: ' + err?.response.data.msg);
    }

    commit('SET_LOADING', { refusing: false });
  },

  acceptCall: async ({ commit, dispatch }, callId) => {
    commit('SET_LOADING', { accepting: true });

    try {
      await Call.accept(callId);
      await dispatch('resetCallAndCloseModal');
    } catch (err) {
      errorLog(err);
      alert('Houve um erro ao aceitar a chamada: ' + err?.response.data.msg);
    }

    commit('SET_LOADING', { accepting: false });
  },

  recipientAcceptCall: (ctx, msg) => {
    if (msg.tipoCliente !== 'DESTINATARIO') return;

    const { callType, id: callId, treatmentId } = filterCall(msg.chamada);

    if (callType == 'VOZ' || callType == 'VIDEO') {
      router.push({ name: 'call', params: { treatmentId, callId } });
    } else {
      router.push({ name: 'treatment', params: { treatmentId } });
    }
  },
};
